import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class RoleEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "Role";
        this.primaryEnterpriseComponent = "Role";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "Role";
        eom.enterpriseComponent = "Role";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "RolePrivilege";
        eom.enterpriseComponent = "RolePrivilege";
        eom.relationship = "RolePrivilege";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "RoleAccountUser";
        eom.enterpriseComponent = "RoleAccountUser";
        eom.relationship = "RoleRoleAccountUser";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default RoleEnterpriseObjectMetadata;